import React from "react";
import { Route } from "react-router";
import TaskDetail from "./task-detail";

export function getRouters(prefix: string) {
  return <Route path={`${prefix}/task/:taskId(\\d+)`} component={TaskDetail} />;
}
